import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React, { useEffect } from "react";
import Constraints from "./Constraints";
import Assumptions from "./Assumptions";
import WeightageFactors from "./WeightageFactors";
import Controllers from "./Controllers";
import { useDispatch, useSelector } from "react-redux";
import Steps from "./Steps";
import Step2 from "../../Stepper/Step2";
import { ConstraintsWithWeightage } from "./ConstraintsWithWeightage/ConstraintsWithWeightage";
import { NestedSteps } from "./NestedSteps/NestedSteps";

const Bounds = () => {
  const dispatch = useDispatch();
  const bounds = useSelector((state) => state.app.bounds);

  useEffect(() => {
    console.log("bounds changing : ", bounds);
  }, [bounds]);

  // useEffect(() => {
  //   console.log(JSON.stringify(bounds));
  // }, [bounds]);

  return (
    <Tabs isFitted w="100%" isLazy={true}>
      <TabList mb="1em">
        <Tab
          _selected={{
            borderBottom: "3px solid #1a174e",
            backgroundColor: "gray.200",
            borderRadius: "5px 5px 0 0",
          }}
        >
          CONSTRAINTS
        </Tab>
        <Tab
          _selected={{
            borderBottom: "3px solid #1a174e",
            backgroundColor: "gray.200",
            borderRadius: "5px 5px 0 0",
          }}
        >
          STEPS
        </Tab>
        {/* <Tab
          _selected={{
            borderBottom: "3px solid #1a174e",
            backgroundColor: "gray.200",
            borderRadius: "5px 5px 0 0",
          }}
        >
          ASSUMPTIONS
        </Tab>
        <Tab
          _selected={{
            borderBottom: "3px solid #1a174e",
            backgroundColor: "gray.200",
            borderRadius: "5px 5px 0 0",
          }}
        >
          WEIGHTAGE FACTORS
        </Tab>
        <Tab
          _selected={{
            borderBottom: "3px solid #1a174e",
            backgroundColor: "gray.200",
            borderRadius: "5px 5px 0 0",
          }}
        >
          CONTROLLERS
        </Tab> */}
      </TabList>
      <TabPanels maxH={"70vh"} overflow={"auto"}>
        <TabPanel>
          <ConstraintsWithWeightage />
        </TabPanel>
        <TabPanel>
          <NestedSteps />
        </TabPanel>
        {/* <TabPanel>
          <Assumptions />
        </TabPanel>
        <TabPanel>
          <WeightageFactors />
        </TabPanel>
        <TabPanel>
          <Controllers />
        </TabPanel> */}
      </TabPanels>
    </Tabs>
  );
};

export default Bounds;
